export default __webpack_public_path__ + "static/media/plain-sticker-z.dea3a71d.png";